<template>
  <common-card class="mt-3">
    <v-row>
      <v-col>
        <v-row style="padding: 15px 20px 0px 20px">
          <v-col cols="12" md="6">
            <h1>Solicitudes Post-Venta</h1>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Filtros -->
    <v-expansion-panels
      elevation="0"
      style="padding: 30px; border-radius: 20px"
    >
      <v-expansion-panel>
        <v-expansion-panel-header style="padding: 35px">
          <h3 style="color: #42352e">Búsqueda detallada</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <!-- Empresa -->
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="filtros.empresa"
                label="Empresa"
                :items="empresas"
                item-text="empresa"
                item-value="id"
                outlined
                multiple
                color="primary"
                background-color="white"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="selectAllEmpresas">
                    <v-list-item-content>
                      <v-list-item-title> Seleccionar Todas </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Cuenta correo -->
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="filtros.cuenta"
                label="Cuenta correo"
                :items="cuentasCorreo"
                item-text="cuenta"
                item-value="id"
                outlined
                multiple
                color="primary"
                background-color="white"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="selectAllCuentas">
                    <v-list-item-content>
                      <v-list-item-title> Seleccionar Todas </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Fechas -->
            <v-col cols="12" md="3">
              <InputPeriodo
                @updateDate="updateDate"
                :bgColor="'white'"
                :inicialDates="false"
                :cleanDates="cleanDates"
                style="min-width: 50%"
              ></InputPeriodo>
              
            </v-col>

            <!-- Estatus solicitud -->
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="filtros.status"
                label="Estatus Solicitud"
                :items="status"
                item-text="label"
                item-value="value"
                outlined
                multiple
                color="primary"
                background-color="white"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="selectAllStatus">
                    <v-list-item-content>
                      <v-list-item-title> Seleccionar Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Ejecutivo -->
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filtros.ejecutivo"
                label="Ejecutivo"
                clearable
                :items="ejecutivos"
                item-text="nombreCompleto"
                item-value="id"
                outlined
                color="primary"
                background-color="white"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row style="padding: 0px 40px 0px 40px" class="d-flex justify-end">
            <v-col cols="12" md="2">
              <v-btn
                dark
                block
                outlined
                color="#00a7e4"
                rounded
                @click="clearFilters()"
              >
                Limpiar
              </v-btn>
            </v-col>
            <v-col cols="12" md="2" style="text-align: end" v-if="canDownloadReport">
              <v-btn
                class="common-botton"
                dark
                block
                :loading="loadingReport"
                :disabled="!isValidFilter"
                @click="generarReporteAsync"
              >
                <span>Descargar reporte</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>


  </common-card>
</template>

<script>
import { mainAxios } from "@/mainAxios";
import moment from "moment";
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import InputPeriodo from "@/components/commonComponents/forms/InputPeriodo.vue";
import { getCuentasCorreoListByParams } from "@/services/cuentasCorreo/cuentasCorreo.service";
import { getEmpresasInbound } from "@/services/empresasInbound/EmpresasInbound.js";
import { getSolicitudesPostventaReportAsync } from "@/services/solicitudesPostventa/solicitudesPostventa.service";

export default {
  components: {
    CommonCard,
    InputPeriodo,
  },
  data() {
    return {
      moment,
      
      roles: JSON.parse(localStorage.getItem("roles")),
      status: [
        { label: "Creacion", value: "-1" },
        { label: "Nueva", value: "0" },
        { label: "Asignada", value: "1" },
        { label: "En tramite", value: "2" },
        { label: "Pendiente de Aprobacion", value: "3" },
        { label: "Pendiente de Informacion", value: "4" },
        { label: "Recotizar", value: "5" },
        { label: "Cerrada", value: "6" },
        { label: "Cancelada", value: "7" },
        { label: "Cancelación respuesta", value: "16" },
        { label: "Reasignada", value: "17" },
      ],
      loading: false,
      loadingReport: false,
      loadingDownload: false,
      search: "",
      filtros: {
        empresa: [],
        cuenta: [],
        status: [],
        ejecutivo: "",
        fechaInicio: "",
        fechaFin: "",
        pagina: 1,
        elementosPagina: 10,
      },
      
      cuentasCorreo: [],
      ejecutivos: [],
      empresas: [],
      
      cleanDates: false,
    };
  },

  computed: {
    canDownloadReport() {
      let canView = false;
      let roles = [];
      this.roles.forEach((element) => {
        roles.push(element.rol);
      });
      const rolesToView = [
        "ADMIN",
        "OPERACIONESEMAILS",
        "MANAGEREMAILS",
        "GERENTEPOSTVENTA",
      ];
      roles.forEach((element) => {
        if (rolesToView.includes(element)) {
          canView = true;
        }
      });
      return canView;
    },
    isValidFilter() {
      return this.filtros.fechaInicio && this.filtros.fechaFin;
    },
    
  },

  methods: {
    

    updateDate(date) {
      this.filtros.fechaInicio = date[0] || "";
      this.filtros.fechaFin = date[1] || "";
      
    },

    

    buildFiltrosBody() {
      const body = {
        fechaInicio: this.filtros.fechaInicio,
        fechaFin: this.filtros.fechaFin,
        empresa: this.filtros.empresa,
        cuentas: this.filtros.cuenta,
        status: this.filtros.status,
      };

      if (
        this.filtros.ejecutivo !== null &&
        this.filtros.ejecutivo !== undefined &&
        this.filtros.ejecutivo !== ""
      ) {
        body.ejecutivo = String(this.filtros.ejecutivo);
      }

      return body;
    },

    clearFilters() {
      this.filtros = {
        empresa: [],
        cuenta: [],
        status: [],
        ejecutivo: null,
        fechaInicio: "",
        fechaFin: "",
        pagina: 1,
        elementosPagina: 10,
      };
      this.cleanDates = !this.cleanDates;
    },

    getAgentes() {
      const requestConfig = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      mainAxios
        .get("/v1/agente/list", requestConfig)
        .then(({ data }) => {
          this.ejecutivos = data.map((e) => ({
            correo: e.correo,
            nombreCompleto: e.nombreCompleto,
            id: e.id,
            uuid: e.uuid,
          }));
        })
        .catch((err) => {
          console.error("Error cargando ejecutivos:", err);
        });
    },

    async getCatalogs() {
      this.loading = true;
      try {
        const cuentasCorreo = await getCuentasCorreoListByParams({
          areaNegocioId: localStorage.area_negocio_id,
          elementosPagina: 100
        });
        this.cuentasCorreo = cuentasCorreo.cuentas;

        // Empresas inbound (para filtro Empresa)
        const empresasInbound = await getEmpresasInbound();
        this.empresas = empresasInbound.data.empresas;
      } catch (e) {
        console.error("Error cargando catálogos de cuentas/empresas:", e);
      } finally {
        this.loading = false;
      }
    },

    

    

    async generarReporteAsync() {
      try {
        this.loadingReport = true;

        const body = this.buildFiltrosBody();
        await getSolicitudesPostventaReportAsync(body);

        this.$toast.info(
          "Tu reporte se está generando en segundo plano. Te llegará un correo con el archivo cuando esté listo."
        );
      } catch (error) {
        console.error("Error al generar el reporte en segundo plano:", error);
        this.$toast.error(
          "Ocurrió un error al generar el reporte. Intenta nuevamente."
        );
      } finally {
        this.loadingReport = false;
      }
    },

    selectAllCuentas() {
      if (this.filtros.cuenta.length === this.cuentasCorreo.length) {
        this.filtros.cuenta = [];
      } else {
        this.filtros.cuenta = this.cuentasCorreo.map((cuenta) => cuenta.id);
      }
    },

    selectAllStatus() {
      if (this.filtros.status.length === this.status.length) {
        this.filtros.status = [];
      } else {
        this.filtros.status = this.status.map((status) => status.value);
      }
    },

    selectAllEmpresas() {
      if (this.filtros.empresa.length === this.empresas.length) {
        this.filtros.empresa = [];
      } else {
        this.filtros.empresa = this.empresas.map((empresa) => empresa.id);
      }
    },
  },

  mounted() {
    this.getCatalogs();
    this.getAgentes();
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}

.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(
    .v-expansion-panels--tile
  )
  > .v-expansion-panel--active {
  border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #f6f5f9;
  color: rgba(0, 0, 0, 0.87);
}

.v-alert {
  margin-bottom: 0;
  font-size: 12px;
}
</style>
